import { render, staticRenderFns } from "./p18.vue?vue&type=template&id=45a8dcdf&scoped=true&"
import script from "./p18.vue?vue&type=script&lang=js&"
export * from "./p18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8dcdf",
  null
  
)

export default component.exports